module.exports = __webpack_public_path__ + "static/media/preview_coupon_campaign_2.00325183.svg";